import { Badge } from '@/components/ui/badge';

export function dokVariant(dok) {
  if (dok >= 4) return 'danger';
  if (dok === 3) return 'attention';
  if (dok === 2) return 'warning';
  return 'success';
}

export function dificuldadeVariant(label) {
  if (/fácil|facil/i.test(label)) return 'success';
  if (/difícil|dificil/i.test(label)) return 'danger';
  return 'warning';
}

function DetailSection({ title, children }) {
  return (
    <section className="mb-5">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral">{title}</h4>
      <div className="bg-neutral-lightest/30 rounded-md border border-neutral-lightest p-3 text-sm text-foreground">{children}</div>
    </section>
  );
}

function KV({ k, v }) {
  return (
    <div className="flex flex-col">
      <span className="text-xs text-neutral">{k}</span>
      <span className="text-sm font-medium text-foreground">{v ?? '—'}</span>
    </div>
  );
}

export default function DescriptorDetail({ d, componentLabel }) {
  if (!d) return null;
  return (
    <>
      <div className="mb-4 flex flex-wrap items-center gap-2">
        {componentLabel && <Badge variant="neutral-lightest">{componentLabel}</Badge>}
        <Badge variant={dokVariant(d.dok_target)}>DOK target {d.dok_target}</Badge>
        {d.dok_ceiling && d.dok_ceiling !== d.dok_target && <Badge variant="neutral-lightest">DOK ceiling {d.dok_ceiling}</Badge>}
        <Badge variant={dificuldadeVariant(d.dif_qual)}>{d.dif_qual}</Badge>
        <Badge variant="info">{d.faixa_tri}</Badge>
        {d.peso_pct != null && <Badge variant="neutral-lightest">peso {d.peso_pct}%</Badge>}
      </div>

      <DetailSection title="Identidade pedagógica">
        <div className="grid grid-cols-2 gap-3">
          <KV
            k="Eixo cognitivo SAEB"
            v={d.eixo_cog_saeb}
          />
          <KV
            k="Verbo de comando"
            v={d.verbo}
          />
          <KV
            k="Bloom · processo"
            v={d.bloom_proc}
          />
          <KV
            k="Bloom · conhecimento"
            v={d.bloom_conh}
          />
        </div>
      </DetailSection>

      <DetailSection title="Conteúdo cognitivo">
        <div className="space-y-3">
          <div>
            <div className="mb-1 text-xs text-neutral">Claim</div>
            <p className="text-sm text-foreground">{d.claim}</p>
          </div>
          <div>
            <div className="mb-1 text-xs text-neutral">Evidência necessária</div>
            <p className="text-sm text-foreground">{d.evidencia}</p>
          </div>
          <div>
            <div className="mb-1 text-xs text-neutral">Objeto de conhecimento</div>
            <p className="text-sm text-foreground">{d.objeto}</p>
          </div>
        </div>
      </DetailSection>

      <DetailSection title="Contexto e referência">
        <div className="grid grid-cols-2 gap-3">
          <KV
            k="BNCC"
            v={d.bncc_em}
          />
          <KV
            k="Contexto sugerido"
            v={d.contexto}
          />
          <KV
            k="Gênero / situação-problema"
            v={d.genero}
          />
        </div>
      </DetailSection>

      <DetailSection title="Erros típicos (distratores)">
        <p className="text-sm text-foreground">{d.erros_distratores}</p>
      </DetailSection>

      <DetailSection title="Item shell de referência">
        <pre className="whitespace-pre-wrap font-mono text-xs text-foreground">{d.item_shell}</pre>
      </DetailSection>

      <DetailSection title="Instruções específicas para IA">
        <pre className="whitespace-pre-wrap font-mono text-xs text-foreground">{d.prompt_ia}</pre>
      </DetailSection>
    </>
  );
}
